
// Types
import { EditSavedPaymentDetailsProps } from './EditSavedPaymentDetails.types';

// Config
import { getLast4Digits } from '../../../utils/helpers/cardDetails';
import { cardTypeText } from '../../../utils/helpers/cardLogos';
import { useWindowSize } from '../../../context/window/WindowSizeContext';

// Components
import { BillingDetails, PaymentCardDelete } from '../card-details/billing-details';
import SavedPaymentDetailsForm from '../saved-payment-details-form';
import BodyText from '../../body-text';

// Styles
import styles from './edit-saved-payment-details.scss';

const EditSavedPaymentDetails = ({
  hideCvv = false,
  paymentDetails = {},
  resetAfterError,
}: EditSavedPaymentDetailsProps) => {
  const { isDesktop: showDeleteButtonResolution } = useWindowSize();

  const renderCardDetails = () => {
    const cardNumberLastFourDigitsShown = paymentDetails && paymentDetails.obfuscatedPan
      ? paymentDetails.obfuscatedPan.slice(0, -4).replace(/./g, '*') + getLast4Digits(paymentDetails.obfuscatedPan)
      : '';

    return (
      <>
        <div>
          <BodyText className={styles.capitalizeText} marginBottom="2" maskText>{paymentDetails.nameOnCard}</BodyText>
          {showDeleteButtonResolution && (
            <div className={styles.paymentCardDeleteButton}>
              <PaymentCardDelete />
            </div>
          )}
        </div>
        <BodyText marginBottom="2" maskText>{`${cardTypeText(paymentDetails.type || '')} ${cardNumberLastFourDigitsShown}`}</BodyText>
        <dl className={styles.expiryAndDelete}>
          <dt className={styles.descriptionTerm}>Exp:</dt>
          <dd className={styles.descriptionDetail} data-testid="description-detail">
            <BodyText maskText>{paymentDetails.expirationMonth}/{(paymentDetails.expirationYear || '').slice(-2)}</BodyText>
          </dd>
        </dl>
      </>
    );
  };

  return (
    <div className={styles.container}>

      {renderCardDetails()}

      {!hideCvv && (
        <SavedPaymentDetailsForm
          paymentDetails={paymentDetails}
          resetAfterError={resetAfterError}
          securityCodeOnly
          useInitialValues
        />
      )}

      <BillingDetails showPaymentCardDelete />
    </div>
  );
};

export default EditSavedPaymentDetails;
